// extracted by mini-css-extract-plugin
export default {"card":"PhotoCard_card__6ZUWc","image":"PhotoCard_image__J+naQ","updateDiv":"PhotoCard_updateDiv__k-vok","deleteDiv":"PhotoCard_deleteDiv__ybUGW","icon":"PhotoCard_icon__3IK1G"};